import { cn } from "@omni/utils/styles";

import { LinkComponentProps } from "./link.props";

const Link = ({ children, className, ...props }: LinkComponentProps) => {
    return (
        <a
            className={cn(
                "tw:text-primary tw:bg-transparent tw:hover:underline",
                "tw:hover:text-primary-focus",
                className
            )}
            {...props}
        >
            {children}
        </a>
    );
};

export { Link };
